import { CommonApiService } from '@app/services/common-api.service';
import { unwrapVioResponseData } from './vio-api-response';
import { extractHttpErrorMessage } from './http-error-message';

export type LessonPptDownloadPayload = {
  downloadRelativePath?: string;
  downloadFileName?: string;
};

function lessonPptFileName(payload: LessonPptDownloadPayload, lessonId: number): string {
  let name = String(payload?.downloadFileName || `lesson_${lessonId}.pptx`).trim();
  if (!name.toLowerCase().endsWith('.pptx')) {
    name = `${name.replace(/\.pptx$/i, '')}.pptx`;
  }
  return name.replace(/[/\\?*:|"<>]+/g, '_');
}

/**
 * After lessonMgmt/generatePPT — stream the file to the browser (no hunting under uploads/).
 */
export function triggerGeneratedLessonPptDownload(
  commonAPI: CommonApiService,
  lessonMgmtBaseUrl: string,
  userId: number,
  lessonId: number,
  data: unknown,
  onMessage: (ok: boolean, message: string) => void,
): void {
  const payload = (unwrapVioResponseData(data) ?? data) as LessonPptDownloadPayload;
  const rel = String(payload?.downloadRelativePath || '').trim();
  const fileName = lessonPptFileName(payload, lessonId);

  if (!rel) {
    onMessage(false, 'PPT was generated but no download path was returned.');
    return;
  }

  const downloadUrl = `${lessonMgmtBaseUrl.replace(/\/$/, '')}/downloadLessonPpt`;
  const body = {
    criteria: {
      userId,
      lessonId,
      relativePath: rel,
      tenant: null,
    },
  };

  commonAPI.postApiCallForFile(downloadUrl, body).subscribe({
    next: (blob) => {
      commonAPI.triggerBrowserFileDownload(blob, fileName);
      onMessage(true, `Download started: ${fileName}`);
    },
    error: (err) => {
      const primary = extractHttpErrorMessage(err);
      commonAPI.downloadUploadRelativeFile(rel).subscribe({
        next: (blob) => {
          commonAPI.triggerBrowserFileDownload(blob, fileName);
          onMessage(true, `Download started: ${fileName}`);
        },
        error: (err2) =>
          onMessage(
            false,
            extractHttpErrorMessage(err2) ||
              primary ||
              'PPT was saved on the server but the browser download failed. Try Generate PPT again.',
          ),
      });
    },
  });
}
